import React from 'react'

import { useState, useEffect,useContext } from "react";
import DateTimePicker from 'react-datetime-picker'

// @mui material components 
import Api from '../../Classes/API/UsersApi';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import GetEmployeeTypesById from '../../Classes/Models/Requests/Administration/Employees/GetEmployeeTypesById';
import MDInput from 'components/MDInput';
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useParams } from 'react-router-dom';
import CreateTherapistEmployeeTypeReq from 'Classes/Models/Requests/Administration/Types/CreateTherapistEmployeeTypeReq';
import Swal from 'sweetalert2';
import CreateFacilityReq from 'Classes/Models/Requests/Administration/CreateFacilityReq'
import TextField from '@mui/material/TextField';
import { LanguageContext } from "App";
import Button from '@mui/material/Button';

import CardHeader from '@mui/material/CardHeader';
import FacilitiesApi from 'Classes/API/Administration/FacilitiesApi';

const EditFacility = () => {

  const { id } = useParams()

  const [name, Setname] = useState('');
  const [accountingEntryId, SetaccountingEntryId] = useState('');
  const [category, Setcategory] = useState('');
  const [currentPrice, SetcurrentPrice] = useState('');
  const [datePurchased, SetdatePurchased] = useState('');
  const [depreciation, Setdepreciation] = useState('');
  const [depreciationRate, SetdepreciationRate] = useState('');
  const [description, Setdescription] = useState('');
  const [getAccountingEntry, SetgetAccountingEntry] = useState('');
  const [getAccountingSessions, SetgetAccountingSessions] = useState('');
  const [getAppointments, SetgetAppointments] = useState('');
  const [image, Setimage] = useState('');
  const [initialPrice, SetinitialPrice] = useState('');
  const [typeId, SettypeId] = useState('');
  const [ErrorText, SetErrorText] = useState(false);
  const [timeStamp, SettimeStamp] = useState('');
  const {translations} = useContext(LanguageContext)
  let employeeModel = new GetEmployeeTypesById();


  useEffect(() => {
    GetData()
  }, ['default']);

  const [IsLoaded, SetIsLoaded] = useState(false);
  const GetData = async () => {
    employeeModel.searchInt = parseInt(id);
    FacilitiesApi.GetFacilityById(employeeModel).then(res => {
      let response = res.data;
      Setname(response.name)
      SetaccountingEntryId(response.accountingEntryId)
      Setcategory(response.category)
      SetcurrentPrice(response.currentPrice)
      SetdatePurchased(response.datePurchased)
      Setdepreciation(response.depreciation)
      SetdepreciationRate(response.depreciationRate)
      Setdescription(response.description)
      SetgetAccountingEntry(response.getAccountingEntry)
      SetgetAccountingSessions(response.getAccountingSessions)
      SetgetAppointments(response.getAppointments)
      Setimage(response.image)
      SetinitialPrice(response.initialPrice)
      SettypeId(response.typeId)
      SettimeStamp(response.timeStamp)
      SetIsLoaded(true)
    })
  }
  useEffect(async () => {
    if (!IsLoaded) {
      await GetData()
    }
  }, [IsLoaded])



  if (!IsLoaded) {
    return (
      <div>
        LOADING...
      </div>
    )
  }



  const submitForm = async () => {
    let object = new CreateFacilityReq();
    object.Id = parseInt(id);
    object.name = name;
    object.accountingEntryId = accountingEntryId;
    object.category = category;
    object.currentPrice = currentPrice;
    object.datePurchased = datePurchased;
    object.depreciation = depreciation;
    object.depreciationRate = depreciationRate;
    object.description = description;
    object.getAccountingEntry = getAccountingEntry;
    object.getAccountingSessions = getAccountingSessions;
    object.getAppointments = getAppointments;
    object.image = null;
    object.initialPrice = initialPrice;
    object.typeId = typeId;
    object.timeStamp = Date.now();

    var editRes = await FacilitiesApi.EditFacility(object)
    if (editRes.status == "Success") {
      Swal.fire('Success', 'Facility Updated Successfully', 'success')
    }
  }


  return (

    <DashboardLayout>
      <DashboardNavbar />
      {/* Page Title */}
      {/* Search form */}
      <div className="card mb-5">
        <div className="card-body">
          <CardHeader className="mb-2" title={translations.FacilityPagesCreatenewFacilityTypeEditFacility}>
          </CardHeader>
          <div className="container-fluid">

            <div className="row">
              <div className="col-md-4 mt-4">
                <MDInput className="full-width" label={translations.FacilityPagesCreatenewFacilityTypename} onChange={(e) => Setname(e.target.value)} defaultValue={name} />
              </div>

              <div className="col-md-4 mt-4">
                <MDInput className="full-width" label={translations.FacilityPagesCreatenewFacilityTypecategory} onChange={(e) => Setcategory(e.target.value)} defaultValue={category} />
              </div>


              <div className="col-md-4 mt-4">
                <TextField className="full-width" label={translations.FacilityPagesCreatenewFacilityTypeCurrentPrice} type="number" onChange={(e) => SetcurrentPrice(e.target.value)} defaultValue={currentPrice} />
              </div>

              <div className="col-md-4 mt-4">
                <MDInput className="full-width" label={translations.FacilityPagesCreatenewFacilityTypeDepreciationRate} onChange={(e) => SetdepreciationRate(e.target.value)} defaultValue={depreciationRate} type="number" />
              </div>

              <div className="col-md-4 mt-4">
                <TextField className="full-width" label={translations.FacilityPagesCreatenewFacilityTypedescription} type="text" onChange={(e) => Setdescription(e.target.value)} defaultValue={description} />
              </div>


              <div className="col-md-4 mt-4">
                <MDInput className="full-width" label={translations.FacilityPagesCreatenewFacilityTypeInitialPrice} onChange={(e) => SetinitialPrice(e.target.value)} defaultValue={initialPrice} type="number" />
              </div>

              <div className="col-md-12 text-right mt-3 ">
                <Button className="white" variant="contained" size="medium" onClick={submitForm}>
                  {translations.FacilityPagesCreatenewFacilityTypeUpdate}
                </Button>
              </div>
            </div>
          </div>
        </div>

      </div>


    </DashboardLayout >

  )
}

export default EditFacility; 